import React from 'react';

import {
  Wrapper,
  IconWrapper,
  TipText,
  TipWrapper,
  ChartWrapper,
  ParentTitle,
  Title,
  TypeTitle,
  MiddleText,
} from './MiddleContent.styles';
import LongArrowIcon from '../LongArrowIcon';
import { ICurrencyFormat } from 'utils/types';
import { PieChart } from '../PieChart';
import { SpendTypeEnum } from 'components/Classification';
import { AllocationTable } from '../AllocationTable';
import { SPEND_LABELS } from 'components/Classification/ClassificationTable/utils';
import { IAllocation } from '../types';
import { getChartData, CHART_COLOR_PALLETTE } from '../PieChart/utils';
import { getTotalPercentage } from '../utils';

interface IProps {
  spendType: SpendTypeEnum;
  parentName?: string | null;
  name?: string | null;
  format: ICurrencyFormat;
  allocations?: IAllocation[];
  spend: number;
  onAppRemove(appId: number): void;
  body?: string;
  title: string;
  dimensionId?: string;
  othersLabel?: string;
}

export const MiddleContent: React.FC<IProps> = ({
  spendType,
  parentName,
  name,
  body,
  allocations,
  format,
  spend,
  title,
  dimensionId,
  othersLabel,
  onAppRemove,
}) => {
  const totalPercentage = allocations ? getTotalPercentage(allocations) : 0;
  const chartData = getChartData(format, spend, allocations || []);
  const isInvalid = totalPercentage > 100;
  // Tweak color pallette as first element is invalid
  const chartColors = isInvalid
    ? [...CHART_COLOR_PALLETTE.slice(-1), ...CHART_COLOR_PALLETTE.slice(0, -1)]
    : CHART_COLOR_PALLETTE;

  if (!name) {
    return (
      <Wrapper>
        <TipWrapper>
          <TipText>
            {body
              ? body
              : 'Please select spend item in left side panel to map to applications'}
          </TipText>
          <IconWrapper>
            <LongArrowIcon />
          </IconWrapper>
        </TipWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ParentTitle>{parentName ? `${parentName} /` : ''}</ParentTitle>
      <Title>{name}</Title>
      <TypeTitle>{SPEND_LABELS[spendType]} spend</TypeTitle>
      <ChartWrapper>
        <MiddleText
          length={String(totalPercentage).length}
          isInvalid={isInvalid}
        >
          {totalPercentage}%
        </MiddleText>
        <PieChart
          data={chartData}
          seriesId={dimensionId || ''}
          colors={chartColors}
        />
      </ChartWrapper>
      {allocations ? (
        <AllocationTable
          spend={spend}
          data={allocations}
          onAppRemove={onAppRemove}
          format={format}
          title={title}
          othersLabel={othersLabel}
        />
      ) : (
        <TipWrapper>
          <TipText>Please allocate spend to the relevant {title}(s)</TipText>
          <IconWrapper reverse>
            <LongArrowIcon />
          </IconWrapper>
        </TipWrapper>
      )}
    </Wrapper>
  );
};
